import { render, staticRenderFns } from "./contact-receiver-options.vue?vue&type=template&id=2f14a90a&scoped=true&"
import script from "./contact-receiver-options.vue?vue&type=script&lang=js&"
export * from "./contact-receiver-options.vue?vue&type=script&lang=js&"
import style0 from "./contact-receiver-options.vue?vue&type=style&index=0&id=2f14a90a&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f14a90a",
  null
  
)

export default component.exports